import { AnimatePresence, motion } from "framer-motion";
import { LearnHub } from "@/features/learn/LearnHub";
import { Tutor } from "@/features/tutor/Tutor";
import { TopicBrowser } from "@/features/topics/TopicBrowser";
import { Flashcards } from "@/features/flashcards/Flashcards";
import { Practice } from "@/features/practice/Practice";
import { ScorePredictor } from "@/features/score/ScorePredictor";
import { Settings } from "@/features/settings/Settings";
import { Resources } from "@/features/resources/Resources";
import { ExamView } from "@/features/exam/ExamView";
import { StudentDashboard } from "@/features/dashboard/StudentDashboard";
import { useWorkspace, type WorkspaceView } from "@/stores/workspace";

const VIEWS: Record<WorkspaceView, () => JSX.Element> = {
  learn: LearnHub,
  dashboard: StudentDashboard,
  tutor: Tutor,
  practice: Practice,
  exam: ExamView,
  topics: TopicBrowser,
  flashcards: Flashcards,
  score: ScorePredictor,
  resources: Resources,
  settings: Settings,
};

export function Workspace() {
  const view = useWorkspace((s) => s.view);
  const Active = VIEWS[view] ?? LearnHub;

  return (
    <AnimatePresence mode="sync">
      <motion.div
        key={view}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -6 }}
        transition={{ duration: 0.22 }}
      >
        <Active />
      </motion.div>
    </AnimatePresence>
  );
}
